import Icon from "./Icon";
import buildingSmall from "../images/ascot-lodge-building-680.jpg";
import buildingLarge from "../images/ascot-lodge-building-1200.jpg";
import { siteDetails } from "../siteContent";

const HeroSection = () => (
  <section className="hero" id="home">
    <div aria-hidden="true" className="hero__shape hero__shape--one" />
    <div aria-hidden="true" className="hero__shape hero__shape--two" />
    <div className="container hero__grid">
      <div className="hero__content">
        <p className="eyebrow">A warm welcome in Southport</p>
        <h1>Care that feels personal. A place that feels like home.</h1>
        <p className="hero__lead">
          Ascot Lodge is a welcoming nursing home for older people, offering
          thoughtful support in a familiar, homely setting.
        </p>
        <div className="button-group">
          <a className="button" href="#contact">
            Arrange a visit
            <Icon name="arrow" size={20} />
          </a>
          <a className="button button--secondary" href={siteDetails.phoneHref}>
            <Icon name="phone" size={20} />
            Call {siteDetails.phoneDisplay}
          </a>
        </div>
        <ul aria-label="Key information" className="hero__highlights">
          <li>
            <Icon name="check" size={19} />
            Nursing and personal care
          </li>
          <li>
            <Icon name="check" size={19} />
            Support for up to 18 people
          </li>
          <li>
            <Icon name="check" size={19} />
            CQC rated Good
          </li>
        </ul>
      </div>

      <div className="hero__visual">
        <div className="hero__image-frame">
          <picture>
            <source
              media="(max-width: 720px)"
              srcSet={`${buildingSmall} 680w`}
            />
            <img
              alt="The red-brick exterior and accessible entrance of Ascot Lodge Nursing Home"
              height="900"
              src={buildingLarge}
              width="1200"
            />
          </picture>
          <div className="hero__address">
            <Icon name="location" size={22} />
            <span>{siteDetails.addressInline}</span>
          </div>
        </div>
        <a
          className="cqc-badge"
          href={siteDetails.cqcUrl}
          rel="noreferrer"
          target="_blank"
        >
          <span className="cqc-badge__label">CQC overall rating</span>
          <strong>Good</strong>
          <span className="cqc-badge__meta">
            Report published {siteDetails.cqcReportDate}
            <Icon name="external" size={16} />
          </span>
        </a>
      </div>
    </div>
  </section>
);

export default HeroSection;
